// src/erp/sale/supervisor_venta/reporte-venta/utils/exportUtils.ts
//import * as XLSX from "xlsx";
import { format } from "date-fns";

export interface ExportColumn { header: string; key?: string; field?: string; width?: number; }
export interface ExportOptions {
  filename?: string;
  title?: string;
  filters?: Record<string, any>;
  summary?: { total: number; aprobadas: number; pendientes: number; tasaConversion: string | number; };
  headerImageUrl?: string;
}

/* ================= EXCEL ================= */

export const exportToExcel = (data: any[], columns: ExportColumn[], options: ExportOptions = {}) => {
  try {
    const { filename = `Reporte_Contratos_Pendientes_${format(new Date(),"yyyy-MM-dd_HH-mm")}.xlsx`,
            title = "Reporte Contratos Pendientes", filters = {}, summary } = options;

    const wb = XLSX.utils.book_new();
    const excelData: any[] = [];
    excelData.push([title], []);

    const activeFilters = Object.entries(filters).filter(([,v]) => v!=null && String(v)!=="");
    if (activeFilters.length) {
      excelData.push(["FILTROS APLICADOS:"]);
      for (const [k,v] of activeFilters) excelData.push([`${k}:`, String(v)]);
      excelData.push([]);
    }

    if (summary) {
      excelData.push(["RESUMEN EJECUTIVO"]);
      excelData.push(["Total de registros:", summary.total]);
      excelData.push(["Exitosas:", summary.aprobadas]);
      excelData.push(["Pendientes:", summary.pendientes]);
    }

    excelData.push(["Fecha de generación:", format(new Date(),"dd/MM/yyyy HH:mm:ss")]);
    excelData.push(["Total visibles en tabla:", data.length], []);
    excelData.push(columns.map(c=>c.header));
    for (const row of data) excelData.push(columns.map(c=>formatCellValue(getNestedValue(row, c.field || c.key || ""))));
    const ws = XLSX.utils.aoa_to_sheet(excelData);
    ws["!cols"] = columns.map(c=>({ wch: c.width || 18 }));
    XLSX.utils.book_append_sheet(wb, ws, "Reporte");
    XLSX.writeFile(wb, filename);
    return true;
  } catch (e) { console.error("Error al exportar a Excel:", e); return false; }
};


const getNestedValue = (obj:any, path:string): any => {
  if (!path || path === "") return undefined;
  return path.split(".").reduce((acc,p)=> (acc? acc[p] : undefined), obj);
};
const formatCellValue = (v:any): string =>
  v==null ? "-" : typeof v==="boolean" ? (v?"SÍ":"NO") :
  v instanceof Date ? format(v,"dd/MM/yyyy HH:mm") :
  typeof v==="number" ? String(v) : typeof v==="object" ? JSON.stringify(v) : String(v);
